// extracted by mini-css-extract-plugin
export default {"modal":"L2OZzvVr9CJW0F9XILhw"};